import { createContext } from 'react';

export const cachedCardMediaDefaultValue = {
	full: new Map(),
	thumbnails: new Map(),
};

// Context that can remember loaded card photos
const CachedCardMediaContext = createContext<{
	full: Map<string, string>;
	thumbnails: Map<string, string>;
}>(cachedCardMediaDefaultValue);

export const maxCacheSize = {
	full: 6,
	thumbnails: 52,
} as const;

export default CachedCardMediaContext;
